import { render, staticRenderFns } from "./my-simple-example-page.vue?vue&type=template&id=581b7397&scoped=true"
import script from "./my-simple-example-page.vue?vue&type=script&lang=js"
export * from "./my-simple-example-page.vue?vue&type=script&lang=js"
import style0 from "./my-simple-example-page.vue?vue&type=style&index=0&id=581b7397&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581b7397",
  null
  
)

export default component.exports